import { render, staticRenderFns } from "./hhqq.vue?vue&type=template&id=88f023fe&"
import script from "./hhqq.vue?vue&type=script&lang=js&"
export * from "./hhqq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports